module.exports = _.startsWith;


//////////////////
// WEBPACK FOOTER
// external "_.startsWith"
// module id = 237
// module chunks = business-manager/shoutout-popup business-manager/video-library-page business-manager/video-module shoutout/shoutout full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings